import { ref } from '@vue/composition-api'
// import { useToast } from 'vue-toastification/composition'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import { getData } from '@core/utils/http/general'

//* Method to fill param request from table 'Pagares'
export const configTablePagares = () => {
  //* This will be our table columns => { key: 'name of the object propiety', label: 'how to show in table' }
  let tblColumFull = []

  tblColumFull = [
    {
      key: 'IdOrden', label: 'Solicitud', sortable: true,
    },
    { key: 'actions' },
    {
      key: 'estado', label: 'Status', sortable: true,
    },
    {
      key: 'fecha_vence', label: 'Vencimiento', sortable: true,
    },
    {
      key: 'matricula', label: 'Alumno', sortable: true,
    },
    {
      key: 'monto', label: 'Total Deuda',
    },
  ]

  //* Params to fill table data & filters
  const configRequest = ref({
    status: null, //* Filter
    wsParams: {
      action: 47, token: store.state.cuenta.session.token, personafk: null, plan: null,
    },
    wsType: 'wscompras',
    filterGetter: 'compras/filterPagares',
  })

  return { tblColumFull, configRequest }
}

//* configuracion para mostrar transacciones / aportaciones
export const configTableAportaciones = () => {
  //* This will be our table columns => { key: 'name of the object propiety', label: 'how to show in table' }
  let tblColumFull = []

  tblColumFull = [
    { key: 'id', label: '#id', sortable: true },
    { key: 'actions' },
    { key: 'show_details', label: 'Detalles' },
    // { key: 'orden', label: 'Ver' },
    { key: 'referencia', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    // { key: 'forma_pago', sortable: true },
    {
      key: 'monto', label: 'Aportación', sortable: true, formatter: val => `$${val}`,
    },
    { key: 'fecha_pago', sortable: true },
    // { key: 'doc' },
    { key: 'factura', sortable: false },
  ]

  //* Params to fill table data & filters APORTACIONES
  const configRequest = ref({
    status: null, //* Filter
    wsParams: {
      action: 1, token: store.state.cuenta.session.token, orden: 0, rol: store.state.cuenta.rolSelected.id, plan: null,
    },
    wsType: (!store.state.cuenta.session.token) ? 'wsinscripcion' : 'wscompras',
    filterGetter: 'compras/filterAportaciones',
  })

  return { tblColumFull, configRequest }
}

// Lista de pagares
export const PagaresxPersona = (personafk, tview) => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 17,
    token: store.state.cuenta.session.token,
    personafk,
    tview,
  }
  getData(paramsRequest, 'wsalumno')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
